/**
 * @generated SignedSource<<5ebdbeb12672b838c9860a754c98777c>>
 * @relayHash fce731839868cdd5f0fc2bc001011ec9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 597ed16ecd3baa9a953b3687c18a17edb827896dcfb8c0cd34c959ab6bf3b3cd

import type { ConcreteRequest } from 'relay-runtime';
export type JiraCFODistributionCategory = "FAIR" | "FAST" | "SLOW" | "%future added value";
export type JiraCFOMetricInsightStatus = "FAST_SETUP" | "INCONCLUSIVE_DATA" | "PERFORMANCE_IMPACT" | "%future added value";
export type UserSetupDimensionCardsQuery$variables = {
  cloudId: string;
  endDate: AGG$DateTime;
  startDate: AGG$DateTime;
};
export type UserSetupDimensionCardsQuery$data = {
  readonly jira: {
    readonly cfoConfigs: {
      readonly clientSetupConfig: ReadonlyArray<{
        readonly distribution: ReadonlyArray<{
          readonly category: JiraCFODistributionCategory | null;
          readonly label: string | null;
        } | null> | null;
        readonly name: string | null;
      } | null> | null;
    } | null;
    readonly cfoInsights: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly metadata: {
            readonly inconclusiveData: ReadonlyArray<{
              readonly isInconclusive: boolean | null;
              readonly name: JiraCFODistributionCategory | null;
            } | null> | null;
            readonly loadTimeDiff: number | null;
          } | null;
          readonly name: string | null;
          readonly status: JiraCFOMetricInsightStatus | null;
        } | null;
      } | null> | null;
    } | null;
    readonly cpuCores: {
      readonly data: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly dimensions?: ReadonlyArray<{
              readonly name: string | null;
              readonly value: string | null;
            } | null> | null;
            readonly metrics?: ReadonlyArray<{
              readonly name: string | null;
              readonly value: number | null;
            } | null> | null;
          } | null;
        } | null> | null;
      };
    };
    readonly networkProtocol: {
      readonly data: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly dimensions?: ReadonlyArray<{
              readonly name: string | null;
              readonly value: string | null;
            } | null> | null;
            readonly metrics?: ReadonlyArray<{
              readonly name: string | null;
              readonly value: number | null;
            } | null> | null;
          } | null;
        } | null> | null;
      };
    };
    readonly networkSpeed: {
      readonly data: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly dimensions?: ReadonlyArray<{
              readonly name: string | null;
              readonly value: string | null;
            } | null> | null;
            readonly metrics?: ReadonlyArray<{
              readonly name: string | null;
              readonly value: number | null;
            } | null> | null;
          } | null;
        } | null> | null;
      };
    };
    readonly operatingSystem: {
      readonly data: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly dimensions?: ReadonlyArray<{
              readonly name: string | null;
              readonly value: string | null;
            } | null> | null;
            readonly metrics?: ReadonlyArray<{
              readonly name: string | null;
              readonly value: number | null;
            } | null> | null;
          } | null;
        } | null> | null;
      };
    };
  };
};
export type UserSetupDimensionCardsQuery = {
  response: UserSetupDimensionCardsQuery$data;
  variables: UserSetupDimensionCardsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = {
  "name": "networkDownlink"
},
v5 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v6 = {
  "kind": "Literal",
  "name": "isV2",
  "value": true
},
v7 = {
  "kind": "Literal",
  "name": "metrics",
  "value": [
    {
      "aggregation": {
        "type": "SUM"
      },
      "alias": "request_count",
      "name": "count"
    },
    {
      "aggregation": {
        "type": "PERCENTILE",
        "value": 0.75
      },
      "alias": "load_time_p75",
      "name": "vc90"
    }
  ]
},
v8 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v9 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "dimensions",
    "value": [
      (v4/*: any*/)
    ]
  },
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "name"
},
v11 = [
  (v10/*: any*/),
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCFODimension",
      "kind": "LinkedField",
      "name": "dimensions",
      "plural": true,
      "selections": (v11/*: any*/)
    },
    {
      "concreteType": "JiraCFOMetric",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": true,
      "selections": (v11/*: any*/)
    }
  ],
  "type": "JiraCFODefaultDataRow"
},
v13 = [
  {
    "kind": "RequiredField",
    "field": {
      "concreteType": "JiraCFODataRowConnection",
      "kind": "LinkedField",
      "name": "data",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraCFODataRowEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v12/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    "action": "THROW"
  }
],
v14 = {
  "name": "cpus"
},
v15 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "dimensions",
    "value": [
      (v14/*: any*/)
    ]
  },
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/)
],
v16 = {
  "name": "httpProtocol"
},
v17 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "dimensions",
    "value": [
      (v16/*: any*/)
    ]
  },
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/)
],
v18 = {
  "name": "osClassification"
},
v19 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "dimensions",
    "value": [
      (v18/*: any*/)
    ]
  },
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/)
],
v20 = [
  (v4/*: any*/),
  (v14/*: any*/),
  (v16/*: any*/),
  (v18/*: any*/)
],
v21 = {
  "args": [
    (v3/*: any*/),
    (v5/*: any*/),
    {
      "kind": "Literal",
      "name": "insightOn",
      "value": (v20/*: any*/)
    },
    (v8/*: any*/)
  ],
  "concreteType": "JiraCFOMetricInsightConnection",
  "kind": "LinkedField",
  "name": "cfoInsights",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraCFOMetricInsightEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraCFOMetricInsight",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            {
              "kind": "ScalarField",
              "name": "status"
            },
            {
              "concreteType": "JiraCFOMetricInsightMetaData",
              "kind": "LinkedField",
              "name": "metadata",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "loadTimeDiff"
                },
                {
                  "concreteType": "JiraCFOInconclusiveData",
                  "kind": "LinkedField",
                  "name": "inconclusiveData",
                  "plural": true,
                  "selections": [
                    (v10/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "isInconclusive"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v22 = {
  "args": [
    (v3/*: any*/),
    {
      "kind": "Literal",
      "name": "dimensions",
      "value": (v20/*: any*/)
    }
  ],
  "concreteType": "JiraCFOConfigsResult",
  "kind": "LinkedField",
  "name": "cfoConfigs",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraCFOClientSetupConfig",
      "kind": "LinkedField",
      "name": "clientSetupConfig",
      "plural": true,
      "selections": [
        (v10/*: any*/),
        {
          "concreteType": "JiraCFODistribution",
          "kind": "LinkedField",
          "name": "distribution",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "category"
            },
            {
              "kind": "ScalarField",
              "name": "label"
            }
          ]
        }
      ]
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v24 = [
  (v23/*: any*/),
  {
    "concreteType": "JiraCFODataRowConnection",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraCFODataRowEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v23/*: any*/),
              (v12/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "UserSetupDimensionCardsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": "networkSpeed",
                "args": (v9/*: any*/),
                "kind": "LinkedField",
                "name": "cfoAnalytics",
                "plural": false,
                "selections": (v13/*: any*/)
              },
              "action": "THROW"
            },
            {
              "kind": "RequiredField",
              "field": {
                "alias": "cpuCores",
                "args": (v15/*: any*/),
                "kind": "LinkedField",
                "name": "cfoAnalytics",
                "plural": false,
                "selections": (v13/*: any*/)
              },
              "action": "THROW"
            },
            {
              "kind": "RequiredField",
              "field": {
                "alias": "networkProtocol",
                "args": (v17/*: any*/),
                "kind": "LinkedField",
                "name": "cfoAnalytics",
                "plural": false,
                "selections": (v13/*: any*/)
              },
              "action": "THROW"
            },
            {
              "kind": "RequiredField",
              "field": {
                "alias": "operatingSystem",
                "args": (v19/*: any*/),
                "kind": "LinkedField",
                "name": "cfoAnalytics",
                "plural": false,
                "selections": (v13/*: any*/)
              },
              "action": "THROW"
            },
            (v21/*: any*/),
            (v22/*: any*/)
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserSetupDimensionCardsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "networkSpeed",
            "args": (v9/*: any*/),
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v24/*: any*/)
          },
          {
            "alias": "cpuCores",
            "args": (v15/*: any*/),
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v24/*: any*/)
          },
          {
            "alias": "networkProtocol",
            "args": (v17/*: any*/),
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v24/*: any*/)
          },
          {
            "alias": "operatingSystem",
            "args": (v19/*: any*/),
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v24/*: any*/)
          },
          (v21/*: any*/),
          (v22/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "597ed16ecd3baa9a953b3687c18a17edb827896dcfb8c0cd34c959ab6bf3b3cd",
    "metadata": {},
    "name": "UserSetupDimensionCardsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "63f40d753f2307b07b86ce00ea827005";

export default node;
